import { getLatestOrder } from "../../../api/pile-sharing";
import { PILE_SHARING_FORM_KEY } from '../../../utils/constants';

export const compareTwoTime = (time1: number[], time2: number[]) => {
    const [hours1, minutes1] = time1
    const [hours2, minutes2] = time2
    if (hours1 < hours2) {
        return false;
    } else if (hours1 > hours2) {
        return true;
    } else {
        // hours1 === hours2
        if (minutes1 < minutes2) {
            return false;
        } else if (minutes1 > minutes2) {
            return true;
        } else {
            // minutes1 === minutes2
            return false;
        }
    }
}

export const isLater = (source: string, target: string) => {
    const time1 = source.split(':').map(Number);
    const time2 = target.split(':').map(Number);

    return compareTwoTime(time1, time2);
};

export const validateTimeValueArray = (time?: string[]) => {
    if (!time) {
        return false
    }
    return compareTwoTime([Number(time[0]), Number(time[1])], [Number(time[2]), Number(time[3])])
}

// 08:00
export const getTimeValueFromTimeString = (str: string) => {
    return str.split(':');
}

export const getCurrentTimeString = (): string => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

export const getCurrentPrice = (priceList: any[]) => {
    const now = getCurrentTimeString();
    const currentPrice = priceList.find(item => {
        // 开始时间点 === 某个时段的分界点，匹配展示
        if (item.startTime === now) {
            return true
        }
        if (isLater(now, item.startTime) && isLater(item.endTime, now)) {
            return true
        }
    })
    return currentPrice
}

export const getCurrentPriceDes = (priceList: any[], fee: any) => {
    if (!priceList && !fee) {
        return {}
    }
    if (fee && !priceList) {
        return {
            time: '00:00~24:00',
            price: fee ? `${fee}元/度` : ''
        }
    }
    const currentPrice = getCurrentPrice(priceList);
    if (!currentPrice) {
        return {
            time: '00:00~24:00',
            price: `0元/度`
        }
    }
    return {
        time: `${currentPrice.startTime}~${currentPrice.endTime}`,
        price: currentPrice.servicePrice ? `${currentPrice.servicePrice}元/度` : ''
    }
}

export const getPileSharingFormFromLocalStorage = async (defaultValue?: any, pileNo = '') => {
    console.log('getPileSharingFormFromLocalStorage', pileNo)
    let formObj: any = { floor: '5' }
    // 新增从最近一次安装工单获取数据逻辑
    if (pileNo) {
        let res = await getLatestOrder({
            pileNo
        })
        console.log('基本', res)
        if ([0, 200].includes(res.code)) {
            formObj = {
                parkingSpaceNo: res?.data?.data?.parkingSpaceNo,
                floor: res?.data?.data?.installFloor,
                billingPeriodList: [
                    { sn: 0, startTime: '00:00', endTime: '24:00', servicePrice: res?.data?.data?.defaultPrice }
                ],
            }
            // 地址信息一并处理 
            if (
                res?.data?.data?.cityCode && res?.data?.data?.city
                &&
                res?.data?.data?.provinceCode && res?.data?.data?.province
                &&
                res?.data?.data?.districtCode && res?.data?.data?.district
                &&
                res?.data?.data?.address
            ) {
                formObj = {
                    ...formObj,
                    cityCode: res?.data?.data?.cityCode,
                    provinceCode: res?.data?.data?.provinceCode,
                    districtCode: res?.data?.data?.districtCode,
                    city: res?.data?.data?.city,
                    province: res?.data?.data?.province,
                    district: res?.data?.data?.district,
                    address: res?.data?.data?.address,
                    name: res?.data?.data?.poiName,
                    longitude: res?.data?.data?.lon,
                    latitude: res?.data?.data?.lat
                }
            }
        }
    }
    const pileSharingForm = localStorage.getItem(PILE_SHARING_FORM_KEY);
    if (!pileSharingForm) {
        return { ...(defaultValue || {}), ...formObj } || null
    }
    const form = JSON.parse(pileSharingForm);
    Object.entries(form).forEach(([key, val]) => {
        if (typeof val === 'string' && val.length === 0) {
            return
        }
        if (typeof val === 'undefined' || val === null) {
            return
        }
        (formObj as any)[key] = val
    })
    console.log(formObj, '回显展示数据')
    return formObj
}


export const setTitle = (title: string) => {
    document.title = title
};


export const transformStringToBoolean = (val: string) => {
    if (val === '1') {
        return true
    }
    if (val === '0') {
        return false
    }
    if (val === 'true') {
        return true
    }
    if (val === 'false') {
        return false
    }
    return false
}


export const hasTimeIntersection = (timevalue1?: string[], timevalue2?: string[]) => {
    if (!timevalue1 || !timevalue2) {
        return false
    }
    const time1 = { start: [Number(timevalue1[0]), Number(timevalue1[1])], end: [Number(timevalue1[2]), Number(timevalue1[3])] };
    const time2 = { start: [Number(timevalue2[0]), Number(timevalue2[1])], end: [Number(timevalue2[2]), Number(timevalue2[3])] };
    // time1.end > time2.start && time1.start < time2.end;
    return compareTwoTime(time1.end, time2.start) || compareTwoTime(time1.start, time2.end)
}


